<div class="stock-modal">
  <div class="stock-modal__header">
    <div>
      <span class="stock-modal__eyebrow">Inventario</span>
      <h2>Aggiungi stock</h2>
      <p *ngIf="productName">
        Aggiungi una nuova riga di stock per <strong>{{ productName }}</strong>
      </p>

      <p *ngIf="variantName" class="variant-name">
        Variante: <strong>{{ variantName }}</strong>
      </p>
    </div>

    <button
      type="button"
      class="stock-modal__close"
      (click)="cancel()"
      [disabled]="loading"
      aria-label="Chiudi"
    >
      ×
    </button>
  </div>

  <form [formGroup]="addStockForm" (ngSubmit)="submit()" class="stock-form">
    <div class="stock-form__highlight">
      <div>
        <label>Quantità <span>*</span></label>
        <input
          type="number"
          formControlName="quantity"
          min="1"
          placeholder="es. 100"
        />

        <small
          class="field-error"
          *ngIf="
            addStockForm.get('quantity')?.invalid &&
            addStockForm.get('quantity')?.touched
          "
        >
          La quantità è obbligatoria e deve essere maggiore di 0.
        </small>
      </div>
    </div>

    <div class="stock-form__grid">
      <div class="form-field">
        <label>Costo unitario</label>
        <input
          type="number"
          formControlName="unitCost"
          min="0"
          step="0.01"
          placeholder="Opzionale"
        />
      </div>

      <div class="form-field">
        <label>Numero lotto</label>
        <input
          type="text"
          formControlName="batchNumber"
          placeholder="es. BATCH-001"
        />
      </div>

      <div class="form-field">
        <label>Data di scadenza</label>
        <input type="date" formControlName="expiryDate" />
      </div>
    </div>

    <div class="form-field">
      <label>Nota</label>
      <textarea
        formControlName="note"
        placeholder="Aggiungi una nota del fornitore, un motivo o un commento interno"
      ></textarea>
    </div>

    <div class="stock-modal__error" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

    <div class="stock-modal__footer">
      <button
        type="button"
        class="btn btn-light"
        (click)="cancel()"
        [disabled]="loading"
      >
        Annulla
      </button>

      <button
        type="submit"
        class="btn btn-primary"
        [disabled]="loading || addStockForm.invalid"
      >
        <span *ngIf="!loading">Aggiungi stock</span>
        <span *ngIf="loading" class="btn-loader">
          <span class="spinner"></span>
          Aggiunta...
        </span>
      </button>
    </div>
  </form>
</div>